<template>
  <div>
    <server-error :error="error"/>
    <div class="row mt-5 b-form__row_type_flex-end">
      <div class="col-4">
        <div class="b-form__container">
          <label>{{$t('CONTENT.assets.base_asset_type')}}:<span class="b-form__required"> *</span></label>
          <cool-select :list="assetsViews"
                       option-value="idInDb"
                       option-text="name"
                       :placeholder="$t('CONTENT.choose')"
                       v-model="underlyingAssetTypeIdModel"
          ></cool-select>
        </div>
      </div>
      <div class="col-4">
        <label for="externalId">
          {{$t('CONTENT.external_id')}}:
          <span class="b-form__required"> *</span>
        </label>
        <input
          data-cy="create-asset-extarnalId"
          type="text"
          class="b-input"
          name="externalId"
          id="externalId"
          v-model="formData.externalId"/>
      </div>
    </div>
    <div class="row mt-5 b-form__row_type_flex-end">
      <div class="col-8">
        <label for="assetName">
          {{$t('CONTENT.assets.asset_name')}}:
          <span class="b-form__required"> *</span>
        </label>
        <input
          data-cy="create-asset-name"
          type="text"
          id="assetName"
          class="b-input"
          name="assetName"
          v-model="formData.name"/>
      </div>
    </div>
    <div class="row mt-5 b-form__row_type_flex-end">
      <div v-if="!isNewBusinessUnit && !isEditBusinessUnit" class="col-8">
        <div class="b-form__container">
          <label>{{$t('CONTENT.assets.business_unit')}}:</label>
          <cool-select :list="businessUnitsViews"
                       option-value="idInDB"
                       option-text="name"
                       :placeholder="$t('CONTENT.choose')"
                       v-model="businessUnitIdModel"
          ></cool-select>
        </div>
      </div>
      <div v-if="isNewBusinessUnit" class="col-4">
        <label for="businessUnitName">
          {{$t('CONTENT.assets.business_unit_name')}}:
        </label>
        <input
          type="text"
          class="b-input"
          name="businessUnitName"
          id="businessUnitName"
          v-model="formData.businessUnitName"/>
      </div>
      <div v-if="isNewBusinessUnit" class="col-4">
        <label for="businessUnitExternalId">
          {{$t('CONTENT.assets.business_unit_id')}}:
        </label>
        <input
          type="text"
          class="b-input"
          name="businessUnitExternalId"
          id="businessUnitExternalId"
          v-model="formData.businessUnitExternalId"/>
      </div>
      <div v-if="isEditBusinessUnit" class="col-4">
        <label for="businessUnitName">
          {{$t('CONTENT.assets.business_unit_name')}}:
        </label>
        <input
          type="text"
          class="b-input"
          name="businessUnitName"
          id="businessUnitName"
          v-model="formData.businessUnitName"/>
      </div>
      <div v-if="isEditBusinessUnit" class="col-4">
        <label for="businessUnitExternalId">
          {{$t('CONTENT.assets.business_unit_id')}}:
        </label>
        <input
          type="text"
          class="b-input"
          name="businessUnitExternalId"
          id="businessUnitExternalId"
          v-model="formData.businessUnitExternalId"/>
      </div>
      <div class="pr-2" v-if="isEditBusinessUnit && !isNewBusinessUnit">
        <button
          type="button"
          class="b-btn b-btn--right"
          @click="saveBusinessUnit()"
        >
          Сохранить БЕ
        </button>
      </div>
      <div class="pr-2" v-if="!isNewBusinessUnit">
        <button
          type="button"
          class="b-btn b-btn_type_add"
          :disabled="businessUnitIdModel == null"
          @click="editBusinessUnit()"
        >
          <dynamic-icon v-if="!isEditBusinessUnit" class="b-btn__icon b-btn__icon_color_main-text" icon="edit"></dynamic-icon>
          <dynamic-icon v-if="isEditBusinessUnit" class="b-btn__icon b-btn__icon_color_main-text" icon="close"></dynamic-icon>
        </button>
      </div>
      <div class="pr-2" v-if="!isEditBusinessUnit">
        <button
          type="button"
          class="b-btn b-btn_type_add"
          @click="selectTypeBusinessUnit()"
        >
          <dynamic-icon v-if="!isNewBusinessUnit" class="b-btn__icon b-btn__icon_color_main-text" icon="plus"></dynamic-icon>
          <dynamic-icon v-if="isNewBusinessUnit" class="b-btn__icon b-btn__icon_color_main-text" icon="close"></dynamic-icon>
        </button>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-6 offset-6">
        <div
          class="b-form__container b-form__container_type_flex b-form__container_type_flex_end"
        >
          <button
            data-cy="save-create-asset"
            class="b-btn b-btn_type_primary"
            type="button"
            @click="saveAsset"
            :disabled="formData.name === undefined || formData.name === '' || isEditBusinessUnit"
          >{{$t('CONTENT.save')}}
          </button>
          <button
            data-cy="cancel-create-asset"
            type="text"
            class="b-btn b-btn_type_empty m-2"
            @click.prevent="closeDialog"
          >{{$t('CONTENT.cancel')}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
	import _ from "lodash";
  import NotificationPopup from "@/components/NotificationPopup.vue";

	export default {
    components: {NotificationPopup},
		props: {
			assetForm: {
				type: Object,
				default: null,
			}
    },
		data() {
			return {
				formData: {},
				currentUnderlyingAssetTypeId: null,
        currentBusinessUnitId: null,
        isNewBusinessUnit: false,
        isEditBusinessUnit: false,
        error: null,
			}
		},
		created() {
			if(this.assetForm !== null) {
				this.formData = _.cloneDeep(this.assetForm);
        this.currentUnderlyingAssetTypeId = this.formData.underlyingAssetTypeId;
        this.currentBusinessUnitId = this.formData.businessUnitId;
      }
		},
    computed: {
			...mapGetters(['getUnderlyingAssetTypes', 'getBusinessUnits']),
      assetsViews() {
        return this.getUnderlyingAssetTypes;
      },
      businessUnitsViews() {
        return this.getBusinessUnits;
      },
      underlyingAssetTypeIdModel: {
			  get() {
          if (this.currentUnderlyingAssetTypeId) {
            return this.currentUnderlyingAssetTypeId;
          } else {
            return null;
          }
        },
        set(newVal) {
          this.currentUnderlyingAssetTypeId = newVal;
        }
      },
      businessUnitIdModel: {
        get() {
          if (this.currentBusinessUnitId) {
            return this.currentBusinessUnitId;
          } else {
            return null;
          }
        },
        set(newVal) {
          this.currentBusinessUnitId = newVal;
        }
      },
    },
    watch: {
      isEditBusinessUnit(newVal) {
        if (newVal && this.currentBusinessUnitId) {
          const selectedBusinessUnit = this.businessUnitsViews.find(
            (unit) => unit.idInDB === this.currentBusinessUnitId
          );
          if (selectedBusinessUnit) {
            this.formData.businessUnitName = selectedBusinessUnit.name;
            this.formData.businessUnitExternalId = selectedBusinessUnit.externalId;
          }
        }
      },
    },
    methods: {
      selectTypeBusinessUnit() {
        this.currentBusinessUnitId = null;
        this.formData.businessUnitName = null;
        this.formData.businessUnitExternalId = null;
        this.isEditBusinessUnit = false;
        this.isNewBusinessUnit = !this.isNewBusinessUnit;
      },
      editBusinessUnit() {
        this.isNewBusinessUnit = false;
        this.isEditBusinessUnit = !this.isEditBusinessUnit;
      },
      async saveBusinessUnit() {
        const updatedBusinessUnit = {
          idInDB: this.currentBusinessUnitId,
          name: this.formData.businessUnitName,
          externalId: this.formData.businessUnitExternalId,
        };
        try {
          await this.$store.dispatch('updateBusinessUnit', updatedBusinessUnit);
          this.isEditBusinessUnit = false;
        } catch (e) {
          this.error = e;
        }
      },
			closeDialog() {
				this.$emit('closeDialog');
			},
			saveAsset() {
        this.formData.underlyingAssetTypeId = this.currentUnderlyingAssetTypeId;
        this.formData.businessUnitId = this.currentBusinessUnitId;
				this.$emit('saveAsset', this.formData);
      }
    }
	}
</script>
